import { useEffect, useState } from 'react';
import { Download, Share2, X } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import './InstallAppPrompt.css';

const InstallAppPrompt = () => {
  const { pathname } = useLocation();
  const [installEvent, setInstallEvent] = useState(null);
  const [dismissed, setDismissed] = useState(() => sessionStorage.getItem('install-prompt-dismissed') === 'true');
  const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && window.navigator.standalone !== true;

  useEffect(() => {
    const onBeforeInstall = (event) => { event.preventDefault(); setInstallEvent(event); };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstall);
  }, []);

  if (!pathname.startsWith('/app/') || dismissed || (!isIos && !installEvent)) return null;

  const dismiss = () => { sessionStorage.setItem('install-prompt-dismissed', 'true'); setDismissed(true); };
  const install = async () => { await installEvent?.prompt(); setInstallEvent(null); };

  return (
    <aside className="install-prompt" aria-label="Install app">
      <div className="install-prompt-copy">
        <strong>Add Utkarsh Abhyasika</strong>
        <span>{isIos ? <>Tap <Share2 size={14} /> then “Add to Home Screen”.</> : 'Install for quick access.'}</span>
      </div>
      {!isIos && <button className="install-action" onClick={install}><Download size={16} /> Install</button>}
      <button className="install-close" onClick={dismiss} aria-label="Dismiss"><X size={18} /></button>
    </aside>
  );
};

export default InstallAppPrompt;
